import { ConfigurationTreeviewEnum } from "../bo/treeview/configuration-treeview.enum";

export abstract class Constants {
  static readonly ConfigurationNiveauUn = [
    { id: ConfigurationTreeviewEnum.Projet, nom: 'GLOBAL.PROJET' },
    { id: ConfigurationTreeviewEnum.Zone, nom: 'GLOBAL.ZONE' },
    { id: ConfigurationTreeviewEnum.TypeTir, nom: 'TREEVIEW.TYPE_TIR' },
    { id: ConfigurationTreeviewEnum.Niveau, nom: 'GLOBAL.NIVEAU' },
    { id: ConfigurationTreeviewEnum.Annee, nom: 'TREEVIEW.ANNEE' },
    { id: ConfigurationTreeviewEnum.month, nom: 'TREEVIEW.MONTH' }
  ];
  static readonly ConfigurationNiveauxAutres = [
    { id: ConfigurationTreeviewEnum.Projet, nom: 'GLOBAL.PROJET' },
    { id: ConfigurationTreeviewEnum.Zone, nom: 'GLOBAL.ZONE' },
    { id: ConfigurationTreeviewEnum.TypeTir, nom: 'TREEVIEW.TYPE_TIR' },
    { id: ConfigurationTreeviewEnum.Niveau, nom: 'GLOBAL.NIVEAU' },
    { id: ConfigurationTreeviewEnum.Annee, nom: 'TREEVIEW.ANNEE' },
    { id: ConfigurationTreeviewEnum.month, nom: 'TREEVIEW.MONTH' },
    { id: ConfigurationTreeviewEnum.Aucun, nom: 'TREEVIEW.AUCUN' },
  ];
  static readonly StockageConfigurationTreeview = 'configuration-treeview';
  static readonly StockageConfigurationFiltrage = 'configuration-treeview-filtrage';
  static readonly StockageTirsChecked = 'configuration-treeview-tirs-checked';

  static readonly StockageConfigurationFiltrageArea = 'configuration-treeview-filtrage-area';



  static readonly SAFE_PATTERN = '^[a-zA-Z0-9_+\\s]*$';
  static readonly ONLY_NUMBER_PATTERN = '^[0-9]*$';
}
